/* tslint:disable */
/* eslint-disable */
export enum ElevatedRequestStatus {
  Pending = 'pending',
  Granted = 'granted',
  Rejected = 'rejected',
  Terminate = 'terminate',
  Terminated = 'terminated',
  Revoked = 'revoked',
  Cancelled = 'cancelled',
  Expired = 'expired',
  Extend = 'extend',
  Resend = 'resend'
}
